import React, { useState } from "react";
import { NavLink,useNavigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const leftMenus = [
  { name: "Home", path: "/dashboard" },
  { name: "Accounts", path: "/accounts", mega: "accounts" },
  { name: "Cards", path: "/cards", mega: "cards" },
  { name: "Payments", path: "/payments", mega: "payments" },
  { name: "Products", path: "/products", mega: "products" },
  { name: "Documents", path: "/documents", mega: "documents" },
];

const TopMenu = ({ onLogoutClick }) => {
  const navigate = useNavigate();

  const location = useLocation();

  const [activeMega, setActiveMega] = useState(null);

  const menuButton =
"relative h-[46px] px-[16px] flex items-center justify-center text-[14px] font-semibold";

const isMenuActive = (item) => {
  if (!item.path) return false;

  if (item.path === "/dashboard") {
    return location.pathname === "/dashboard";
  }

  return location.pathname.startsWith(item.path);
};

  return (
    <div
      className="relative z-40 bg-white border-b border-[#d9d9d9]"
      onMouseLeave={() => setActiveMega(null)}
    >
      {/* TOP BAR */}

      <div className="h-[46px] px-8 flex items-center justify-between">

        {/* LEFT */}

        <div className="flex items-center">

          {leftMenus.map((item) => {
  const isActive = isMenuActive(item);

  return (
    <button
      key={item.name}
      type="button"
      onClick={() => {
        // Only Home navigates
        if (item.name === "Home") {
          navigate(item.path);
        }

        // Mega menu still opens
        if (item.mega) {
          setActiveMega(item.mega);
        }
      }}
      onMouseEnter={() => item.mega && setActiveMega(item.mega)}
      className={`${menuButton}
        ${
          isActive
            ? "bg-[#f4f4f4] text-[#1d1d1d]"
            : "text-[#4a5565] hover:bg-[#f8f8f8]"
        }`}
    >
      <span>{item.name}</span>

      {(isActive || activeMega === item.mega) && (
        <span className="absolute left-0 bottom-0 h-[2px] w-full bg-[#d40000]" />
      )}
    </button>
  );
})}
        </div>

        {/* RIGHT */}

       <div className="flex items-center">

  <button
    type="button"
    className={`
      ${menuButton}
      text-[#4a5565]
      hover:bg-[#f8f8f8]
    `}
  >
    Settings
  </button>



         <button
  onClick={onLogoutClick}
  className="h-[46px] px-[10px] text-[14px] text-[#4a5565] hover:bg-[#f8f8f8] font-semibold"
>
  Logout
</button>

        </div>
      </div>

      {/* MEGA MENU */}

      <AnimatePresence>

        {activeMega && (

          <motion.div
            initial={{
              opacity: 0,
              y: -8,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            exit={{
              opacity: 0,
              y: -8,
            }}
            transition={{
              duration: 0.18,
            }}
            className="
              absolute
              left-0
              top-full
              w-full
              bg-white
              border-t
              border-[#ececec]
              shadow-[0_18px_40px_rgba(0,0,0,0.08)]
            "
          >

            <div className="max-w-[1600px] mx-auto px-10 py-1">

              



{/* ========================= ACCOUNTS ========================= */}

{activeMega === "accounts" && (
  <div className="grid grid-cols-3 gap-0">
    {/* COLUMN 1 */}

    <div className="pr-10 border-r border-[#ececec] pb-4">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Accounts
      </h6>

      <div className="space-y-1.5">
        {[
          {
            label: "Asset overview",
            path: "#",
          },
          {
            label: "Account overview",
            path: "/accounts/accounts-overview",
          },
          {
            label: "Account transactions",
            path: "/accounts/accounts-transaction",
          },
          {
            label: "Balance forecast",
            path: "/accounts/balance-forecast",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>

    {/* COLUMN 2 */}

    <div className="px-10 border-r border-[#ececec] pb-4">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Direct Access
      </h6>

      <div className="space-y-1.5">
        {[
          {
            label: "Open account",
            path: "#",
          },
          {
            label: "Mortgages",
            path: "#",
          },
          {
            label: "Open UBS key4 smart investing",
            path: "#",
          },
          {
            label: "KeyClub overview",
            path: "#",
          },
          {
            label: "Credit limits",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  </div>
)}


{/* ========================= CARDS ========================= */}

{activeMega === "cards" && (
  <div className="grid grid-cols-3 gap-0">
    <div className="pr-10 border-r border-[#ececec] pb-4">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Card
      </h6>

      <div className="space-y-1">
        {[
          {
            label: "Card overview",
            path: "/cards/cards-overview",
          },
          {
            label: "Credit and prepaid Card transactions",
            path: "#",
          },
          {
            label: "Card invoice",
            path: "#",
          },
          {
            label: "Settings for cards",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>

    <div className="px-10 border-r border-[#ececec]">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Direct access
      </h6>

      <div className="space-y-1">
        {[
          {
            label: "Request card",
            path: "#",
          },
          {
            label: "Freeze or Block card",
            path: "#",
          },
          {
            label: "Debit cards - security settings",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  </div>
)}

{/* ========================= PAYMENTS ========================= */}

{activeMega === "payments" && (
  <div className="grid grid-cols-3 gap-0">
    <div className="pr-10 border-r border-[#ececec] pb-2">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Payments
      </h6>

      <div className="space-y-1">
        {[
          {
            label: "Transfer money and pay invoices",
            path: "/payments/transfer-money",
          },
          {
            label: "Payments on record",
            path: "#",
          },
          {
            label: "Files on record",
            path: "#",
          },
          {
            label: "Order foreign currency",
            path: "#",
          },
          {
            label: "Payees and invoicing parties",
            path: "#",
          },
          {
            label: "Account and transaction reports",
            path: "#",
          },
          {
            label: "Report settings",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>

    <div className="px-10 border-r border-[#ececec]">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Direct Access
      </h6>

      <div className="space-y-1">
        {[
          {
            label: "Account transfer",
            path: "/payments/account-transfer",
          },
          {
            label: "Payment to card",
            path: "#",
          },
          {
            label: "Payment to Fiscal account",
            path: "#",
          },
          {
            label: "Standing orders on record",
            path: "#",
          },
          {
            label: "Directory of eBill invoicing parties",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  </div>
)}
{/* ========================= PRODUCTS ========================= */}

{activeMega === "products" && (
  <div className="grid grid-cols-3 gap-0">
    <div className="pr-10 border-r border-[#ececec]">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Products
      </h6>

      {/* <div className="space-y-1">
        {[
          {
            label: "Bank documents",
            path: "#",
          },
          {
            label: "eBill invoices",
            path: "#",
          },
          {
            label: "Statement of assets",
            path: "#",
          },
          {
            label: "Agreements",
            path: "#",
          },
          {
            label: "Settings",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div> */}
    </div>

    <div className="px-10 border-r border-[#ececec] pb-2">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Direct Access
      </h6>

      {/* <div className="space-y-1">
        {[
          {
            label: "Submit documents to UBS",
            path: "#",
          },
          {
            label: "Message to client advisor",
            path: "#",
          },
          {
            label: "Message to support",
            path: "#",
          },
          {
            label: "Set up notifications",
            path: "#",
          },
          {
            label: "Delivery type for bank documents",
            path: "#",
          },
          {
            label: "Online forms",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div> */}
    </div>
  </div>
)}

{/* ========================= DOCUMENTS ========================= */}

{activeMega === "documents" && (
  <div className="grid grid-cols-3 gap-0">
    <div className="pr-10 border-r border-[#ececec]">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Documents
      </h6>

      <div className="space-y-1">
        {[
          {
            label: "Bank documents",
            path: "/documents/bank-documents",
          },
          {
            label: "eBill invoices",
            path: "#",
          },
          {
            label: "Statement of assets",
            path: "#",
          },
          {
            label: "Agreements",
            path: "#",
          },
          {
            label: "Settings",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>

    <div className="px-10 border-r border-[#ececec] pb-2">
      <h6 className="uppercase text-[14px] tracking-[2px] mb-4 mt-4 font-semibold">
        Direct Access
      </h6>

      <div className="space-y-1">
        {[
          {
            label: "Submit documents to UBS",
            path: "#",
          },
          {
            label: "Message to client advisor",
            path: "#",
          },
          {
            label: "Message to support",
            path: "#",
          },
          {
            label: "Set up notifications",
            path: "#",
          },
          {
            label: "Delivery type for bank documents",
            path: "#",
          },
          {
            label: "Online forms",
            path: "#",
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => {
              if (item.path !== "#") {
                navigate(item.path);
                setActiveMega(null);
              }
            }}
            className="w-full text-left px-3 py-1.5 rounded hover:bg-[#f5f5f5] transition text-[14px] text-[#666666] font-semibold"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  </div>
)}
            </div>

          </motion.div>

        )}

      </AnimatePresence>

  
    </div>
  );
};

export default TopMenu;